export enum EnvironmentType {
  Dev = 0,
  SIT = 1,
  UAT = 2,
  Staging = 3,
  Production = 4,
}

export enum ModalType {
  Basic = 1,
  Advance = 2,
}
export enum ActionType {
  Create = 1,
  Edit = 2,
}
export enum ParamsReloadType {
  Reload = 1,
  IsMain = 2,
}
export enum ApplipcationStoreType {
  Peak = 0,
  NewPeak = 1,
  Payroll = 2,
  Board = 3,
  Asset = 4,
  Tax = 5,
}

export enum LoadingStatusType {
  None = 0,
  Loading = 1,
  Success = 2,
  Fail = 3,
}

export enum Locales {
  EN = "en",
  TH = "th",
}

export enum LanguageType {
  Th = 0,
  En = 1,
}
export enum TableSorting {
  DESC = 0,
  ASC = 1,
}
export enum SortingType {
  DESC = 0,
  ASC = 1,
}

export enum UserType {
  Email = 0,
  Google = 1,
}

export enum Package {
  Trial = 0,
  Free = 1,
  Basic = 2,
  Pro = 3,
  ProPlus = 4,
  AFPFree = 5,
  AFPLedger = 6,
  AFPAccountant = 7,
}
export enum Role {
  None = 0,
  ViewOnly = 1, // ดูได้อย่างเดียว
  PartialRightsDraftOnly = 2, //สิทธิบางส่วน ร่างได้อย่างเดียว
  PartialRightsApproveAndReceivePayment = 3, //สิทธิบางส่วน อนุมัติและรับจ่าย
  PartialRightsRevenueOnly = 4, //สิทธิบางส่วน ฝั่งรายได้อย่างเดียว
  PartialRightsExpenseOnly = 5, //สิทธิบางส่วน ฝั่งรายจ่ายอย่างเดียว
  PartialRightsQuotationOnly = 6, //สิทธิบางส่วน ใบเสนอราคาอย่างเดียว
  StandardRightsViewReport = 7,
  StandardRightsNotViewReport = 8,
  Admin = 9,
}
export enum TypeComponentNoti {
  Success = 1,
  Warn = 2,
  Error = 3,
  Upload = 4,
}
export enum AssetTemplateCategoryType {
  None = 0,
  Land = 1,
  ConstructionInProgress = 2,
  Building = 3,
  FurnitureAndFixture = 4,
  Vehicle = 5,
  Machine = 6,
  Equipment = 7,
  Intangible = 8,
}
export enum AssetTemplateSubCategoryType {
  None = 0,
  Land = 1,
  ConstructionInProgress = 2,
  Office = 3,
  Shop = 4,
  Warehouse = 5,
  Factory = 6,
  OtherBuildingAndImprovement = 7,
  BuildingImprovement = 8,
  Fixture = 9,
  Table = 10,
  ChairAndSofa = 11,
  CabineAndStorage = 12,
  OtherFurniture = 13,
  Motocycle = 14,
  CarOrVanLessThan10Seats = 15,
  Truck = 16,
  OtherVehicle = 17,
  Machine = 18,
  Equipment = 19,
  MobliePhone = 20,
  ComputerAndComputerEquipment = 21,
  PrinterOrPrintingEquipment = 22,
  OtherOfficeEquipment = 23,
  Software = 24,
  LeaseholdAndLicense = 25,
  CopyRight = 26,
  Patent = 27,
  OtherIntengibleAssets = 28,
  CarOrVanMoreThan10Seats = 29,
}
export enum AssetTemplateDepreciationPolicyType {
  None = 0,
  NotCalcuated = 1,
  Straight = 2,
}
export enum AccountScrapValType {
  None = 0,
  OneBath = 1,
  TenPercent = 2,
  Custom = 3,
}
export enum AccountScrapType {
  Amount = 0,
  Percent = 1,
}
export enum AccountPurchaseValType {
  None = 0,
  NotHave = 1,
  Custom = 2,
}
export enum AccountPurchaseType {
  Amount = 0,
  Percent = 1,
}

export enum AccountDepreciationMethodType {
  NotCalcuated = 1,
  Straight = 2,
  Custom = 3,
}

/* eslint-disable @typescript-eslint/camelcase */
export enum NotificationMessageType {
  None = 0,
  Quotation = 1,
  PurcahseOrder = 2,
  Invoice = 3,
  InvoiceAllProduct = 4,
  Expense = 5,
  ExpenseAllProduct = 6,
  PurchaseAsset = 7,
  PurchaseAssetAllProduct = 8,
  Receipt = 9,
  StockActivityStockCardMovement = 10,
  TaxInvoice = 11,
  TaxInvoiceInRevenueDepartmentFormat = 12,
  TrialBalanceWithSubAccount = 13,
  TrialBalance = 14,
  PurcahseTaxInvoice = 15,
  PurchaseTaxInvoiceInRevenueDepartFormat = 16,
  Journal = 17,
  BillingNoteInvoice = 18,
  BillingNoteInvoiceAllInvoice = 19,
  BillingNoteExpense = 20,
  BillingNoteExpenseAllExpense = 21,
  Finance = 22,
  PP30InputVat = 23,
  PP30OutputVat = 24,
  CreditNote = 25,
  CreditNoteExpense = 26,
  AssetTemplateGroup = 27,
  AssetTemplate = 28,
  WithHeldTax = 29,
  WithHoldingTax = 30,
  GeneralLedgerTransaction = 31,
  AllGeneralLedger = 32,
  AllGeneralLedgerWithSubAccount = 33,
  AgingReportAR = 34,
  AgingReportAP = 35,
  Product = 36,
  ProfitLoss = 37,
  ChartOfAccount = 38,
  BalanceSheet = 39,
  Unit = 40,
  ReportDocument = 41,
  Asset = 42,
  StatementEFiling = 43,
  AllReport = 44,
  Contact = 45,
  PurchaseTaxInvoiceNotUse = 46,
  SalesTaxInvoiceNotUse = 47,
  PP30TaxFilingTextFile = 48,
  WithHoldingTaxPND2 = 49,
  WithHoldingTaxPND3 = 50,
  WithHoldingTaxPND53 = 51,
  CashflowStatementReport = 52,
  AllReportSalesByCustomerReport = 53,
  AllReportSalesByAccountReport = 54,
  AllReport_RemainingFinanceBalanceReport = 55,
  StatementEFilingExcel = 56,
  AllReportProductSalesByContact = 57,
  AllReport_ProductServiceSalesSummaryReportOnDailyAccount = 58,
  Pnd53TaxFilingTextFile = 59,
  Pnd3TaxFilingTextFile = 60,
  DailyJournal = 61,
  DocumentQuotation = 62,
  DocumentInvoice = 63,
  DocumentReceipt = 64,
  DocumentTaxInvoice = 65,
  DocumentPurchaseOrder = 66,
  DocumentExpense = 67,
  DocumentBillingNote = 68,
  DocumentBillingNoteExpense = 69,
  DocumentCreditNote = 70,
  DocumentCreditNoteExpense = 71,
  DocumentPurchaseTaxInvoice = 72,
  DocumentWithholdingTax = 73,
  ImportTransactionPurchaseInventory = 74,
  ImportTransactionExpense = 75,
  ImportTransactionInvoice = 76,
  ImportTransactionReceipt = 77,
  ImportTransactionQuotation = 78,
  ImportTransactionPurchaseOrder = 79,
  Statement = 80,
  AllReportWithHoldingTaxPND2 = 81,
  AllReportWithHoldingTaxPND3 = 82,
  AllReportWithHoldingTaxPND53 = 83,
  ChequeReport = 84,
  WorkingPaper = 85,
  RecalCostOfGoodSoldByMerchantCalculated = 86,
  RecalCostOfGoodSoldByProductCalculated = 87,
  RecalCostOfGoodSoldFailed = 88,
  DebitNote = 89,
  DocumentDebitNote = 90,
  DebitNoteExpense = 91,
  DocumentDebitNoteExpense = 92,
  VoidImportTransactionFailed = 93,
  TrialBalanceSeperateMonth = 94,
  VoidImportTransactionSuccess = 95,
  ImportTransactionReceiptFromInvoice = 96,
  ImportTransactionJournal = 97,
  DepreciateAssetMonthly = 98,
  TaxPnd = 99,
  TaxPP30SaleTax = 100,
  TaxPP30PurchaseTax = 101,
  TaxFetchPP30Transaction = 102,
  TaxFetchWhtCertificate = 103,
  AllReportPurchaseTaxInvoiceNotUseFromPeakTax = 104,
  AllReportSalesTaxInvoiceNotUseFromPeakTax = 105,
  AllReportTaxInvoiceFromPeakTax = 106,
  AllReportPurchaseTaxInvoiceFromPeakTax = 107,
  AllReportPurchaseTaxInvoiceNotUseFromOldPeak = 108,
  AllReportSalesTaxInvoiceNotUseFromOldPeak = 109,
  AllReportTaxInvoiceFromOldPeak = 110,
  AllReportPurchaseTaxInvoiceFromOldPeak = 111,
  FinanceBankStatement = 112,
  ExecutiveSummary = 113,
  StatementOfCashflow = 114,
  RecieveBenefit = 115,
  CamPaignBeforeExpire = 116,
  BeforeExpireByDate = 117,
  QuotaExpire = 118,
}
export enum TransactionType {
  None = 0,
  Quotation = 1,
  Invoice = 2,
  Receipt = 3,
  TaxInvoice = 4,
  CreditNote = 5,
  BillingNote = 6,
  DebitNote = 7,
  PP30 = 8,
  Pnd53 = 9,
  Pnd3 = 10,
  Dailyjournal = 11,
  WithholdingTax = 12,
}
export enum StopAssetDepreciationType {
  None = 0,
  StopAssetDepreciation = 1,
  SaleAsset = 2,
}

export enum AssetDepreciationStatus {
  CancelingDepreciate = -1,
  WaitingDepreciate = 0,
  Depreciated = 1,
  AdjustDepreciated = 2,
}
export enum TransactionItemType {
  None = 0,
  Service = 1,
  Inventory = 2,
  Asset = 3,
}

export enum MerchantType {
  None = 0,
  LimitedLiabilityPartnership = 1,
  CompanyLimited = 2,
  PublicCompanyLimited = 3,
  Shop = 4,
  OrdinaryPerson = 5,
  BodyOfPersons = 6,
  Others = 7,
  OrdinaryPartnership = 8,
  Foundation = 9, //มูลนิธิ
  Association = 10,
  JointVenture = 11,
}

export enum ExpenseType {
  None = 0,
  Expense = 1,
  PurchaseInventory = 2,
  PurchaseAsset = 3,
}
export enum ExceptionCode {
  None = 0,
  TransactionNumberDuplicated = 1,
  ContactNotFound = 2,
  ProductNotFound = 3,
  AccountNotFound = 4,
  LockByPeriod = 5,
  FreePackageOverCreateTransaction = 6,
  ProPlusImportTransaction = 7,
  FullPaymentAmount = 8,
  InputFieldEmptry = 9,
  TransactionIsVoided = 10,
  OverPaid = 11,
  ProductNameAndDescriptionIsDuplicated = 12,
  ProductTemplateCodeIsDuplicated = 13,
  AccountCodeIsDuplicated = 14,
  UnitCodeIsDuplicated = 15,
  BankAccountCodeIsDuplicated = 16,
  ContactCodeIsDuplicated = 17,
  TaxIdIsDuplicated = 18,
  ContactNameIsDuplicated = 19,
  IssuedTaxInvoiceDuplicated = 20,
  PaymentIsDeleted = 21,
  ApprovedTransactionDuplicated = 22,
  AcceptedQuotationDuplicated = 23,
  CanNotVoidInvoiceIsIssuedBillingNote = 24,
  CanNotVoidInvoiceIsIssuedCreditNote = 25,
  CanNotVoidReceiptIsIssuedCreditNote = 26,
  LockByUser = 27,
  LockBySystem = 28,
  LockByIssuedPP30 = 29,
  LockBySendEtaxInvoice = 30,
  CanNotVoidQuotationIsIssuedInvoice = 31,
  CanNotVoidQuotationIsIssuedReceipt = 32,
  CanNotCreateDuplicatedReceiptFromReferenceTransaction = 33,
  IssuedDuplicatedTaxInvoice = 34,
  ReceivedTaxInvoiceVatTotalOverflow = 35,
  ReceivedTaxInvoicePreVatTotalOverflow = 36,
  UserProfileIsAlready = 37,
  EmailPasswordIncorrect = 38,
  ContactIdBelongToMerchant = 39,
  MerchantIsVerified = 40,
  ReceivedTaxInvoiceNumberDuplicated = 41,
  DuplicateNameContactGroup = 42,
  ImportTransactionExceed = 43,
  IsHaveUserInSystem = 44,
  DuplicatedReferFriends = 45,
  DuplicateFileName = 46,
  CanNotVoidInvoiceIsIssuedDebitNote = 47,
  CanNotVoidReceiptIsIssuedDebitNote = 48,
  BankAccountNotFound = 49,
  OverInvitationUser = 50,
  UserAlreadyMerchant = 51,
  MerchantPackageIsNotAddUser = 52,
  CanNotEditSuperUser = 53,
  UserUpdateEqualEditUser = 54,
  CanNotRemoveSuperUser = 55,
  CanNotRemoveUser = 56,
  DuplicatedSettingNumberIndextString = 57,
  AuthorityRoleNotPermission = 58,
  NotHavePermissionUser = 59,
  NotHavePermissionFinance = 60,
  NotHavePermissionPayroll = 61,
  NotHavePermissionPeakBoard = 62,
  ApiPartnerNotFound = 63,
  MerchantIsNotAllowDuplicateContact = 64,
  CanNotDeleteThisFinance = 65,
  CanNotVoidAllocation = 66,
  CanNotVoidAllocationItem = 67,
  CanNotIsArchivedAllocationIncome = 68,
  CanNotIsArchivedAllocationExpense = 69,
  LockByIssuedPND3 = 70,
  LockByIssuedPND53 = 71,
  CanNotEditDocumentIsIssuedFromPayroll = 72,
  CreditLimitCannontCreate = 73,
  CreditLimitWarning = 74,
  CanNotVoidPaymentIsIssuedReceipt = 75,
  InvalidDocumentPassCode = 76,
  CanNotEditTransactionIsIssuedDebitNote = 77,
  CanNotEditTransactionIsIssuedCreditNote = 78,
  CanNotEditJournal = 79,
  CanNotUpdateJournalStatus = 80,
  CanNotVoidProductTemplate = 81,
  ProductTemplateNameCanNotEmpty = 82,
  CanNotAddProductTemplatePrice = 83,
  ProductTemplatePriceNameDuplicated = 84,
  InvalidINetAuthenticationData = 85,
  AssetPurchaseDateLessThanStopAssetDepreciationDate = 86,
  PackageErrorCode = 87,
  UpgradeToPackageErrorCode = 88,
  AssetTemplateCodeDuplicated = 89,
  CanNotEditTransactionAsset = 90,
  CanNotVoidAssetTemplateBecauseAssetTemplateIssuedAsset = 91,
  CanNotVoidAssetBecauseAssetIssuedByPurchaseAsset = 92,
  CanNotVoidAssetBecauseAssetIssuedBySaleAsset = 93,
  OverLimitAsset = 94,
  BillingTransactionCurrencyNotCorrect = 95,
  DuplicatedReceiveBillingNoteNumber = 96,
  CanNotSaleAssetBecauseDoesNotSelectAssetId = 97,
  CanNotSaleAssetBecauseSaleAssetDateLessThanStopDepreciationDate = 98,
  IsNotHaveContactRevenueDepartment = 99,
  IsNotHaveContactSalary = 100,
  IsNotHaveContactSSO = 101,
  CantDoPaymentIsHaveErrorPndType = 102,
  CanNotVoidUnit = 103,
  ChequeReceivedAndClearing = 104,
  ChartOfAccountCannotDeleted = 105,
  UserIsInSystemAlready = 106,
  UserNotFound = 107,
  InvitationIncorrect = 108,
  InvitationIncorrectOrExpired = 109,
  AssetTemplateIsDeleted = 110,
  OverCreditNoteAmount = 111,
  OverPaymentCreditNoteAmount = 112,
  CanNotCreateCreditNote = 113,
  CreditNoteDateLessThanReferenceTransactionDate = 114,
  CanNotVoidTransactionIsHaveReferenceDocumentPayment = 115,
  OverPaidReferenceDocumentPayment = 116,
  IsReferenceTransactionIssuedCreditNote = 117,
  IssueCreditNoteAmountOverReferenceCreditNote = 118,
  CannotVoidPaymentHavePND = 119,
  CanNotEditTransactionIsIssuedReferencePaymentDocument = 120,
  CanNotEditTransactionIsIssuedPayment = 121,
  CanNotCreateCreditNoteBecauseTransactionRefIsIssuedDebitNote = 122,
  CanNotCreateCreditNoteBecauseTransactionRefIsNoDebt = 123,
  CanNotCreateDebitNoteBecauseTransactionRefIsIssuedCreditNote = 124,
  CanNotGotReceiptBecauseNotHavePayment = 125,
  CanNotVoidBillingNoteBecausePaid = 126,
}
export enum AuthorityRole {
  None = 0,
  ViewOnly = 1,
  PartialRights = 2,
  StandardRights = 3,
  Admin = 4,
}
export enum UserRight {
  None = 0,
  ViewOnly = 1,
  RevenueExpenseDraftOnly = 2,
  RevenueExpenseApproveOnly = 3,
  RevenueAll = 4,
  ExpenseAll = 5,
  QuotationOnly = 6,
  Standard = 7,
  BasicAndAdmin = 8,
  CreateRevenueOnly = 9,
  CreateExpenseOnly = 10,
  PurchaseOrderOnly = 11,
  RevenueDraftOnly = 12,
  ExpenseDraftOnly = 13,
  RevenueApproveOnly = 14,
  ExpenseApproveOnly = 15,
  QuotationDraftOnly = 16,
  QuotationApproveOnly = 17,
  PurchaseOrderDraftOnly = 18,
  PurchaseOrderApproveOnly = 19,
  ExpenseExceptPOAll = 20,
  RevenueExceptQOAll = 21,
  RevenueExpenseExceptQOandPOApproveOnly = 22,
}
export enum ActivityLogSource {
  None = 0,
  PEAK_Engine = 1,
  PEAK_Experience = 2,
  PEAK_API = 3,
  TransactionImport = 4,
  ZORT = 5,
  KetShopWeb = 6,
  XCommerce = 7,
  BentoWeb = 8,
  Wisible = 9,
  Empeo = 10,
  Recurring = 11,
  BoxMe = 12,
  PeakAsset = 13,
  LineConnect = 14,
  UCommerce = 15,
  Page365 = 16,
  PeakPayroll = 17,
  PeakBoard = 18,
  PeakTax = 19,
}
export enum ValidatedErrorCarryBalanceType {
  None = 0,
  Depreciation = 1,
  ScrapValue = 2,
  LockByPeriod = 3,
}
export enum FinanceAndAccountRights {
  None = 0,
  All = 1,
  FinanceAccessOnly = 2,
  GLAndStatementOnly = 3,
  DailyJournalsAll = 4,
  DailyJournalsDraftOnly = 5,
  DailyJournalsApproveOnly = 6,
  DailyJournalsAllAndFinance = 7,
  DailyJournalsDraftOnlyAndFinance = 8,
  DailyJournalsApproveOnlyAndFinance = 9,
  DailyJournalsAllAndGL = 10,
  DailyJournalsDraftOnlyAndGL = 11,
  DailyJournalsApproveOnlyAndGL = 12,
  FinanceAccountAndDailyJournalsDraftOnly = 13,
  FinanceAccountAndDailyJournalsApproveOnly = 14,
  FinanceAndGL = 15,
}

export enum SourceTypeProject {
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
  LineConnect = 4,
  PeakPayroll = 5,
  PeakAdmin = 6,
  PeakAsset = 7,
}

export enum VideoFeedback {
  None = 0,
  Yes = 1,
  No = 2,
  Complete = 3,
  Submit = 4,
}

export enum Position {
  None = -1,
  Other = 0,
  BusinessOwner = 1,
  Bookkeeper = 2,
  Salesperson = 3,
  Admin = 4,
  Accountant = 5,
  Employee = 6,
  AccountingFirm = 7,
  Student = 8,
}

export enum BroadcastUserChannelType {
  None = 0,
  AuthenticatedNotification = 1,
  DisconnectNotification = 2,
  UpdateNotificationList = 3,
  MasterDeleteNotificationById = 4,
  UpdateNotificationCount = 5,
  MasterGetNotificationListByMerchantId = 6,
  MasterGetNotificationCountByMerchantId = 7,
  DisconnectNotificationAllTab = 8,
  ReCreateTab = 9,
  MasterSetNotificationIsSeenAll = 10,
}

export enum AuthenticatedNotification {
  Success = 1,
  Failed = 2,
}

export enum BroadcastTabChannelType {
  None = 0,
  MasterTabClose = 1,
}
